import { Injectable } from '@angular/core';
import { NativeBridgeService } from './native-bridge.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ConfirmarDialogComponent } from '../../shared/components/confirmar-dialog/confirmar-dialog.component';
import { PrintTicketMessage } from '../models/interfaces/print-ticket-message';
import { RestService } from './rest.service';
import { GeneralConstants } from '../constants/general.constants';
import { NotificationService } from './notification.service';
import { deviceMessageId } from '../enums/device-message-id.enum';
import { apkBridgeProperties } from '../enums/apk-bridge-properties';
import { CloverService } from './clover.service';

@Injectable({
  providedIn: 'root'
})
export class PrintCloverTicketService {
  constructor(
    private nativeBridgeService: NativeBridgeService,
    private dialog: MatDialog,
    private restService: RestService,
    private notificationService: NotificationService,
    private cloverService: CloverService
  ) {}

  openPrintTicketConfirmationPopup(movementId: number) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      id: 1,
      info: 'Imprimir comprobante',
      title: '¿Está seguro que desea imprimir el comprobante?'
    };
    const dialogRef = this.dialog.open(ConfirmarDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(async (response) => {
      if (response) {
        this.sendTicketToDevice(movementId);
      }
    });
  }

  sendTicketToDevice(movementId: number) {
    if (this.nativeBridgeService.nativeBridgeIsActive(apkBridgeProperties.ANDROID_BRIDGE)) {
      this.getTicketInformation(movementId)
        .then((resp) => {
          if (resp.object) {
            const ticket: PrintTicketMessage = {
              message_id: deviceMessageId.ACTION_PRINT_RECEIPT,
              title: resp.object.title.nombre,
              company_name: resp.object.companyName,
              date: this.formatDateTime(resp.object.date),
              time: this.getTime(resp.object.date),
              cuit: this.formatCuit(resp.object.cuit),
              address: resp.object.address,
              terminal_id: this.cloverService.getTerminalId() ? parseInt(this.cloverService.getTerminalId()) : 0,
              amount_pesos: 'ARS ' + this.formatCurrency(resp.object.amountPesos),
              amount_usd: 'USD ' + this.formatCurrency(resp.object.amountUsd),
              conversion_rate: 'ARS ' + this.formatCurrency(resp.object.conversionRate),
              pix_id: movementId,
              state: resp.object.status,
              discount_percentage_usd:
                resp.object.porcentajeDescuentoAplicado > 0
                  ? resp.object.porcentajeDescuentoAplicado.toString() + '%'
                  : null,
              discount_net_usd:
                resp.object.montoDescuentoAplicadoDolares > 0
                  ? 'USD ' + this.formatCurrency(resp.object.montoDescuentoAplicadoDolares)
                  : null
            };
            try {
              if (this.nativeBridgeService && this.nativeBridgeService.nativeBridgeIsActive('androidBridge')) {
                this.nativeBridgeService.sendMessageToDevice(
                  JSON.stringify({ message_id: deviceMessageId.DOWNLOADING_TICKET })
                );
                this.nativeBridgeService.sendMessageToDevice(JSON.stringify(ticket));
                console.log(`Sent ${deviceMessageId.DOWNLOADING_TICKET} to bridge`);
              } else {
                console.warn('Bridge not available, try later');
              }
              this.notificationService.showSuccess('Imprimiendo comprobante');
            } catch (error) {
              this.notificationService.showError('Error al imprimir comprobante');
            }
          }
        })
        .catch((error) => {
          this.notificationService.showError('Error al obtener datos del comprobante');
        });
    } else {
      this.notificationService.showError('Impresión de comprobante no disponible en este dispositivo');
    }
  }

  getTicketInformation(movementId: number) {
    const endpoint = GeneralConstants.getTktInfo + movementId.toString();
    return this.restService.get(endpoint);
  }

  formatCurrency(number: number): string {
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2
    });

    return formatter.format(number).slice(1);
  }

  formatCuit(cuit: string): string {
    if (cuit.length < 11) {
      return cuit;
    }
    const lastCharacter = cuit.charAt(cuit.length - 1);
    const middleSubstring = cuit.substring(2, cuit.length - 1);
    return `${cuit.substring(0, 2)}-${middleSubstring}-${lastCharacter}`;
  }

  formatDateTime(dateTimeString: string): string {
    const dateTime = new Date(dateTimeString);

    const day = dateTime.getDate().toString().padStart(2, '0');
    const month = (dateTime.getMonth() + 1).toString().padStart(2, '0');
    const year = dateTime.getFullYear().toString();

    return `${day}-${month}-${year}`;
  }

  getTime(dateTimeString: string): string {
    const dateTime = new Date(dateTimeString);
    const hours = dateTime.getHours();
    const minutes = dateTime.getMinutes();
    const seconds = dateTime.getSeconds();

    const formattedHours = hours.toString().padStart(2, '0');
    const formattedMinutes = minutes.toString().padStart(2, '0');
    const formattedSeconds = seconds.toString().padStart(2, '0');

    return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
  }
}
